const urlBase = 'https://app.beforevault.com/';
export default urlBase;